import { defineComponent as _defineComponent } from 'vue'


type Props = {
  id: string;
  text: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectionsPreview',
  props: {
    id: null,
    text: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})